import { useState } from 'react';
import { Bell, Settings as SettingsIcon, Shield, Users } from 'lucide-react';
import AdminUsersTab from './tabs/AdminUsersTab';
import GeneralSettingsTab from './tabs/GeneralSettingsTab';
import NotificationsTab from './tabs/NotificationsTab';
import RolesTab from './tabs/RolesTab';

type TabType = 'admins' | 'roles' | 'general' | 'notifications';

export default function Settings() {
  const [activeTab, setActiveTab] = useState<TabType>('admins');

  const tabs = [
    { id: 'admins' as const, label: 'User Management', icon: Users },
    { id: 'roles' as const, label: 'Role Management', icon: Shield },
    { id: 'general' as const, label: 'General Settings', icon: SettingsIcon },
    { id: 'notifications' as const, label: 'Notifications', icon: Bell }
  ];

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow-lg p-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-2xl font-bold text-gray-900 flex items-center">
              <SettingsIcon className="w-7 h-7 mr-3 text-green-600" />
              Settings
            </h1>
            <p className="text-gray-600 mt-1">Manage users, roles, and system configuration</p>
          </div>
        </div>

        <div className="border-b border-gray-200">
          <nav className="flex space-x-8">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center space-x-2 py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                  activeTab === tab.id
                    ? 'border-green-500 text-green-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
                type="button"
              >
                <tab.icon className="w-5 h-5" />
                <span>{tab.label}</span>
              </button>
            ))}
          </nav>
        </div>
      </div>

      {activeTab === 'admins' ? <AdminUsersTab /> : null}
      {activeTab === 'roles' ? <RolesTab /> : null}
      {activeTab === 'general' ? <GeneralSettingsTab /> : null}
      {activeTab === 'notifications' ? <NotificationsTab /> : null}
    </div>
  );
}
